// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-5bc3e15c]{fill:#fff}.cls-2[data-v-5bc3e15c]{-webkit-filter:url(#Transp_Weiss_Flamme);filter:url(#Transp_Weiss_Flamme)}", ""]);
// Exports
module.exports = exports;
